var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 10.3333V22H2.00098V10.3333H22.001ZM22.001 8.66667V6.16667C22.001 5.50363 21.7376 4.86774 21.2687 4.3989C20.7999 3.93006 20.164 3.66667 19.501 3.66667H17.001V2H15.3343V3.66667H8.66764V2H7.00098V3.66667H4.50098C3.83794 3.66667 3.20205 3.93006 2.73321 4.3989C2.26437 4.86774 2.00098 5.50363 2.00098 6.16667L2.00098 8.66667H22.001ZM17.001 13.6667H15.3343V15.3333H17.001V13.6667ZM12.8343 13.6667H11.1676V15.3333H12.8343V13.6667ZM8.66764 13.6667H7.00098V15.3333H8.66764V13.6667ZM17.001 17H15.3343V18.6667H17.001V17ZM12.8343 17H11.1676V18.6667H12.8343V17ZM8.66764 17H7.00098V18.6667H8.66764V17Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b0eb4dd338b0eed886be7b42bf87588c.svg";
export { ForwardRef as ReactComponent };